import { useEffect } from 'react'
import { IntlProvider } from 'react-intl'
import { ThemeProvider } from '@mui/material'
import wfTheme, { loadHellixFont, licenseKey } from '@wf/mui-theme'
import { LicenseInfo } from '@mui/x-license'

import { useLocale, SupportedLocales } from '@/Shared/locale'
import { AppRouter } from '@/AppRouter'
import { QueryClientProvider } from '@/QueryClientProvider'

LicenseInfo.setLicenseKey(licenseKey)

const locale: SupportedLocales = 'en'

function App() {
    const messages = useLocale(locale)

    useEffect(() => {
        loadHellixFont()
    }, [])

    return (
        <IntlProvider locale={locale} defaultLocale="en" key={locale} messages={messages}>
            <ThemeProvider theme={wfTheme}>
                <QueryClientProvider>
                    <AppRouter />
                </QueryClientProvider>
            </ThemeProvider>
        </IntlProvider>
    )
}

export default App
